import tempMeeApi from '../../../apis/tempMee';

// The BE stores the per-line cap in cents (max_payout_amount_cents, int64).
export const createPromotion = async ({ name, maxPayoutAmountCents }) => {
  const response = await tempMeeApi.post(
    '/payment/admin/promotion-campaigns',
    { name, max_payout_amount_cents: maxPayoutAmountCents },
  );

  return response.data;
};
